// Third Party
import { ImageLoaderProps } from 'next/image';

// Utils
import { relativePath } from './string-helpers';
import getConfig from '@config';

function normalizeSrc(src: string) {
  return src[0] === '/' ? src.slice(1) : src;
}

export function imagekitLoader({
  src,
  width,
  quality = 85,
}: ImageLoaderProps): string {
  const imagekitEndpoint = getConfig().publicRuntimeConfig.imagekitEndpoint;

  // https://docs.imagekit.io/features/image-transformations/resize-crop-and-other-transformations
  const params = [
    'f-auto',
    'fo-auto',
    'c-at_max',
    `w-${width}`,
    `q-${quality}`,
  ];

  const parts = relativePath(src).split('?');
  const path = parts[0];
  const originalParams = parts[1];
  let paramsString = '?';
  if (originalParams) {
    paramsString += originalParams + '&';
  }
  paramsString += 'tr=' + params.join(',');

  return `${imagekitEndpoint}/${normalizeSrc(path)}${paramsString}`;
}

export function imagekitProgressiveLoader({
  src,
  width,
  quality = 85,
}: ImageLoaderProps): string {
  const imagekitEndpoint = getConfig().publicRuntimeConfig.imagekitEndpoint;

  const params = [
    'f-jpg',
    'pr-true',
    'fo-auto',
    'c-at_max',
    `w-${width}`,
    `q-${quality}`,
  ];

  const parts = relativePath(src).split('?');
  const path = parts[0];
  const originalParams = parts[1];
  let paramsString = '?';
  if (originalParams) {
    paramsString += originalParams + '&';
  }
  paramsString += 'tr=' + params.join(',');

  return `${imagekitEndpoint}/${normalizeSrc(path)}${paramsString}`;
}
